<template>
  <div>
    <Row :gutter="8" class="m-b-10">
      <i-col span="3">
        <Select
          size="small"
          placeholder="选择所属线路"
          v-model="query.assetId"
          clearable
        >
          <i-option
            v-for="item in assetArray"
            :key="'asset_' + item.id"
            :value="item.id"
          >
            {{ item.name }}
          </i-option>
        </Select>
      </i-col>
      <i-col span="3">
        <Select
          size="small"
          placeholder="选择通信资产类型"
          v-model="query.devicemodel"
          clearable
        >
          <i-option
            v-for="item in deviceModelArray"
            :key="'smallmodel_' + item.id"
            :value="item.id"
          >
            {{ item.name }}
          </i-option>
        </Select>
      </i-col>
      <i-col span="4">
        <i-input v-model="query.keyword" size="small"
          placeholder="关键字 (资源CODE）"
        ></i-input>
      </i-col>
      <i-col span="6">
        <Button
          type="primary"
          icon="ios-search"
          size="small"
          class="m-r-5"
          @click="handleSearch"
        >搜索</Button>
        <i-button
          size="small"
          type="success"
          class="m-r-5"
          @click="handleCreate"
        >
          新建通信资产
        </i-button>
         <i-button
          size="small"
          type="success"
          :loading="exportsLoading"
          @click="handleExports"
        >{{ exportsLoading ? '数据生成中...' : '导出通信资产清单' }}</i-button>
      </i-col>
    </Row>

    <Table :columns="tableColumns" :data="tableData.list" stripe :loading="tableLoading" size="small"></Table>
    <div class="paging_style">
      <Page
        size="small"
        :total="tableData.totalRow"
        :page-size="query.pageSize"
        show-total
        show-elevator
        show-sizer
        :current="query.pageNumber"
        @on-change="handleChangePage"
        :page-size-opts="pagesizeSetting"
        @on-page-size-change='changePageSize'
      ></Page>
    </div>

    <Modify ref="modifyRef"
      :assetArray="assetArray"
      :deviceModelArray="deviceModelArray"
      :optionType="optionType"
      :curDeviceInfo="curInfo"
      :onSuccess="getTableData"/>

    <SaleRecords ref="saleRecordsRef"/>
  </div>
</template>

<script>
// components
import Modify from './Modify.vue'
import SaleRecords from './SaleRecords.vue'
// utils
import { downloadFileRequest } from '@/utils/download'
// apis
import { getMaintenanceAssetList, getDeviceModelList } from '@/api/rim/asset'
import { getEstateDevicePage, startExportDevice } from '@/api/rim/device'

export default {
  components: {
    Modify, SaleRecords
  },
  data () {
    return {
      optionType: 1,
      curInfo: {},

      assetArray: [],
      deviceModelArray: [],

      exportsLoading: false,
      sign: '',

      query: {
        pageNumber: 1,
        pageSize: 15,
        assetId: undefined,
        deviceBigmodel: 5, // 获取通信资产
        devicemodel: undefined,
        assetIdList: undefined,
        keyword: ''
      },

      pagesizeSetting: [15, 50, 100, 200, 500],
      tableLoading: false,
      tableData: {
        list: [],
        totalRow: 0
      },
      tableColumns: [
        { title: '资产名称', key: 'code' },
        { title: '通信资产类型', key: 'devicemodelName' },
        { title: '所属线路', key: 'assetName' },
        { title: '位置名称', key: 'stationName' },
        { title: '设备位置', key: 'positionName' },
        {
          title: '正线里程(km)',
          key: 'length',
          render: (h, params) => {
            return h('span', params.row.length > 0 ? params.row.length : '-')
          }
        },
        {
          title: '车站建筑面积(㎡)',
          key: 'buildArea',
          render: (h, params) => {
            return h('span', params.row.buildArea > 0 ? params.row.buildArea : '-')
          }
        },
        {
          title: '机房数量(个)',
          key: 'machineNumber',
          render: (h, params) => {
            return h('span', params.row.machineNumber > 0 ? params.row.machineNumber : '-')
          }
        },
        {
          title: '设备点使用面积(㎡)',
          key: 'machineNumber',
          render: (h, params) => {
            return h('span', params.row.useArea > 0 ? params.row.useArea : '-')
          }
        },
        // { title: '配电限额(kw)', key: 'name' },
        // { title: '设备点复用', key: 'name' },
        { title: '产权单位', key: 'manageUnitName' },
        { title: '管理单位', key: 'usingUnitName' },
        {
          title: '操作',
          align: 'center',
          fixed: 'right',
          width: 200,
          render: (h, params) => {
            return h('div', [
              h('a', {
                style: { marginRight: '5px' },
                on: {
                  click: () => {
                    this.handleEdit(params.row)
                  }
                }
              }, '编辑'),
              h('a', {
                style: { marginRight: '5px' },
                on: {
                  click: () => {
                    this.handleSaleRecords(params.row)
                  }
                }
              }, '租赁详情')
            ])
          }
        }
      ]
    }
  },
  created () {
    this.initBaseData()
  },
  methods: {
    initBaseData () {
      this.getAssetData()
      this.getTableData()
    },
    getTableData () {
      this.tableLoading = true

      getEstateDevicePage(this.query).then(res => {
        if (res && !res.errcode) {
          this.tableData = res
        } else {
          this.tableData.list = []
          this.tableData.totalRow = 0
        }
      }).finally(() => { this.tableLoading = false })
    },
    getAssetData () {
      getMaintenanceAssetList().then(res => {
        if (res && !res.errcode) {
          this.assetArray = res
          this.query.assetIdList = JSON.stringify(res.map(x => x.id))
          this.getDeviceModelData()
        } else {
          this.assetArray = []
        }
      })
    },
    getDeviceModelData () {
      const query = {
        assetIds: JSON.stringify(this.assetArray.map(x => x.id)),
        deviceBigModel: 5
      }

      getDeviceModelList(query).then(res => {
        this.deviceModelArray = res
      })
    },
    handleSearch () {
      this.query.pageNumber = 1
      this.getTableData()
    },
    handleChangePage (curPage) {
      this.query.pageNumber = curPage
      this.getTableData()
    },
    changePageSize (pageSize) {
      this.query.pageSize = pageSize
      this.query.pageNumber = 1
      this.getTableData()
    },
    handleExports () {
      this.sign = ''
      this.exportsLoading = true
      this.fileDownload()
    },
    fileDownload () {
      const downloadParams = {
        assetIds: this.query.assetId ? JSON.stringify([this.query.assetId]) : this.query.assetIdList,
        sign: this.sign,
        deviceBigModels: JSON.stringify([this.query.deviceBigmodel])
      }

      startExportDevice(downloadParams).then(res => {
        if (res) {
          this.sign = res.sign
          if (res.status === 2) {
            const filename = '通信资产清单.xls'
            downloadFileRequest(process.env.VUE_APP_API_URL_V2 + '/ooh-rim/v1/device/downloadexcel', { sign: this.sign }, filename)
            this.exportsLoading = false
          } else if (res.status === -1) {
            this.exportsLoading = false
            this.$Notice.error({ title: '操作提示', desc: '下载失败，请稍后重试！' })
          } else {
            setTimeout(() => {
              this.fileDownload()
            }, 3000)
          }
        } else {
          this.exportsLoading = false
        }
      }).catch((_err) => {
        this.exportsLoading = false
      })
    },
    handleCreate () {
      this.optionType = 1
      this.$nextTick(() => {
        this.$refs.modifyRef.showModal()
      })
    },
    handleEdit (params) {
      this.optionType = 2
      this.curInfo = params
      this.$nextTick(() => {
        this.$refs.modifyRef.showModal()
      })
    },
    handleSaleRecords (params) {
      this.$nextTick(() => {
        this.$refs.saleRecordsRef.showModal(params)
      })
    }
  }
}
</script>
